'use client'
import { createContext, useContext } from "react";
const defaultTableRowDrawerContentContext = {
    isDrawerContent: false
};
const TableRowDrawerContentContext = /*#__PURE__*/ createContext(defaultTableRowDrawerContentContext);
const useTableRowDrawerContentContext = ()=>useContext(TableRowDrawerContentContext);
export { TableRowDrawerContentContext, defaultTableRowDrawerContentContext, useTableRowDrawerContentContext };
